import ComputerList from './ComputerList';

export default ComputerList;
